import { 
  getFirestore, doc, setDoc, addDoc,getDoc, updateDoc, deleteDoc, 
  collection, getDocs, query, where, increment
} from "firebase/firestore";

import Product from "./FoodCost";

const db = getFirestore();

// Liste des unités disponibles avec labels
const UNITS = [
  { value: 'kg', label: 'Kilogramme' },
  { value: 'g', label: 'Gramme' },
  { value: 'l', label: 'Litre' },
  { value: 'mL', label: 'Millilitre' },
  { value: 'piece', label: 'Pièce' },
  { value: 'bottle', label: 'Bouteille' },
  { value: 'pack', label: 'Paquet' }
];

class Stock {
  constructor(productName, pricePerUnit, date, quantity, unit, restaurantId) {
    this.productName = productName;
    this.pricePerUnit = pricePerUnit;
    this.date = date;
    this.quantity = quantity;
    this.unit = unit;
    this.restaurantId = restaurantId;
    this.validateUnit();
  }




static normalizeUnit(unit) {
  // Ajouter une vérification de null/undefined
  if (!unit) {
    console.error('Unité non définie - Valeur par défaut utilisée');
    return 'piece'; // Valeur par défaut
  }

  const unitMap = {
    'bouteille': 'bottle',
    'litre': 'L',
    'kg': 'kg',
    'g': 'g',
    'ml': 'mL',
    'pièce': 'piece',
    'sachet': 'pack'
  };

  // Gérer les entrées en majuscules/accents
  const cleanedUnit = unit.toString().toLowerCase().trim();
  return unitMap[cleanedUnit] || cleanedUnit;
}

validateUnit() {
  if (!this.unit) {
    throw new Error('Le champ unité est requis');
  }
  
  const normalizedUnit = Stock.normalizeUnit(this.unit);
  
  if (!UNITS.some(u => u.value === normalizedUnit)) {
    throw new Error(`Unité "${this.unit}" non valide`);
  }
  
  this.unit = normalizedUnit;
}
  async addStock() {
    try {
      const stocksRef = collection(db, "stocks");
      const q = query(
        stocksRef, 
        where("productName", "==", this.productName), 
        where("restaurantId", "==", this.restaurantId),
        where("unit", "==", this.unit)
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const existingDoc = querySnapshot.docs[0];
        await updateDoc(existingDoc.ref, {
          quantity: increment(parseFloat(this.quantity)),
          
          pricePerUnit: Number(this.pricePerUnit),
          date: this.date
        });
        return { success: true, message: 'Stock mis à jour avec succès' };
      } else {
        const newStockRef = doc(stocksRef);
        await setDoc(newStockRef, {
          productName: this.productName,
          pricePerUnit: Number(this.pricePerUnit),
          date: this.date,
          quantity: parseFloat(this.quantity),

          unit: this.unit,
          restaurantId: this.restaurantId,
          createdAt: new Date().toISOString()
        });
        return { success: true, message: 'Stock créé avec succès' };
      }
    } catch (error) {
      console.error('Erreur stock:', error);
      return { 
        success: false, 
        message: error.message || 'Erreur lors de la gestion du stock'
      };
    }
  }

  static async updateStock(stockId, updatedData) {
    try {
      const stockRef = doc(db, "stocks", stockId);
      const oldStockSnap = await getDoc(stockRef);
  
      if (!oldStockSnap.exists()) {
        throw new Error('Stock introuvable');
      }
  
      const oldStock = oldStockSnap.data();
  
      // Normalize unit if present in update
      if (updatedData.unit) {
        updatedData.unit = Stock.normalizeUnit(updatedData.unit);
        if (!UNITS.some(u => u.value === updatedData.unit)) {
          throw new Error(`Unité "${updatedData.unit}" non valide`);
        }
      }
  
      // Unit change confirmation
      if (updatedData.unit && updatedData.unit !== oldStock.unit) {
        const confirmation = window.confirm(
          `Changer l'unité de ${Stock.getUnitLabel(oldStock.unit)} à ${Stock.getUnitLabel(updatedData.unit)} ? 
          Cela nécessitera une mise à jour manuelle des produits associés !`
        );
        if (!confirmation) {
          return { success: false, message: 'Modification annulée' };
        }
      }
  
      // Prepare numeric updates
      const numericUpdates = {};
      if (updatedData.quantity !== undefined) numericUpdates.quantity = parseFloat(updatedData.quantity);
      if (updatedData.pricePerUnit !== undefined) numericUpdates.pricePerUnit = Number(updatedData.pricePerUnit);
  
      // Perform update
      await updateDoc(stockRef, {
        ...updatedData,
        ...numericUpdates,
        updatedAt: new Date().toISOString()
      });
  
      // Update related products with correct restaurantId
      const stockSnap = await getDoc(stockRef);
      const stockName = stockSnap.data().productName;
      const restaurantId = stockSnap.data().restaurantId;

      const productsRef = collection(db, "products");
      const q = query(productsRef, where("restaurantId", "==", restaurantId));
      const productsSnap = await getDocs(q);
      
      const updatePromises = [];
      productsSnap.forEach(doc => {
        if (doc.data().ingredients.some(i => i.stockName === stockName)) {
          const product = new Product(
            doc.data().name,
            doc.data().soldPrice,
            doc.data().restaurantId,
            doc.data().image,
            doc.data().ingredients
          );
          product.id = doc.id;
          updatePromises.push(product.calculateAndUpdateCost());
        }
      });

      await Promise.all(updatePromises);
  
      // Optionally, wait for all updates to finish
     
  
      return { success: true, message: 'Stock mis à jour avec succès' };
    } catch (error) {
      console.error('Erreur mise à jour stock:', error);
      return { success: false, message: error.message };
    }
  }
  

  // Méthode deleteStock simplifiée
static async deleteStock(stockId) {
  try {
    const stockRef = doc(db, "stocks", stockId);
    await deleteDoc(stockRef);
    return { success: true, message: 'Stock supprimé avec succès' };
  } catch (error) {
    console.error('Erreur suppression stock:', error);
    return { 
      success: false, 
      message: error.message || 'Erreur lors de la suppression du stock'
    };
  }
}
  
  static async getAllStocks(restaurantId) {
    try {
      const stocksRef = collection(db, "stocks");
      const q = query(stocksRef, where("restaurantId", "==", restaurantId));
      const stockDocs = await getDocs(q);
      return stockDocs.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
      console.error('Error getting stocks:', error.message);
      throw error;
    }
  }

  static getUnitLabel(unitValue) {
    const unit = UNITS.find(u => u.value === unitValue);
    return unit ? unit.label : 'Unité inconnue';
  }

  static getAvailableUnits() {
    return UNITS.map(unit => ({
      value: unit.value,
      label: `${unit.label} (${unit.value})`
    }));
  }
static async addProduitIntermediaire(produitData) {
  try {
    const db = getFirestore();
    const produitsRef = collection(db, 'stocks');
    
    const produitWithMetadata = {
      ...produitData,
      isProduitIntermediaire: true,
      isComposite: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      quantity: produitData.quantiteProduite
    };
    
    await addDoc(produitsRef, produitWithMetadata);
    return true;
  } catch (error) {
    console.error("Error adding produit intermédiaire:", error);
    throw error;
  }
}

static async getAllStocks(restaurantId) {
  try {
    const db = getFirestore();
    const stocksRef = collection(db, 'stocks');
    const q = query(stocksRef, where('restaurantId', '==', restaurantId));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching all stocks:", error);
    throw error;
  }
}

// Helper function to normalize unit
static normalizeUnit(unit) {
  const units = {
    'kilogramme': 'kg',
    'kilogram': 'kg',
    'kilo': 'kg',
    'gramme': 'g',
    'gram': 'g',
    'litre': 'l',
    'liter': 'l',
    'millilitre': 'ml',
    'milliliter': 'ml',
    'piece': 'piece',
    'pièce': 'piece',
    'portion': 'portion'
  };
  return units[unit?.toLowerCase()] || unit || 'piece';
}

static getAvailableUnits() {
  return [
    { value: 'kg', label: 'Kilogramme (kg)' },
    { value: 'g', label: 'Gramme (g)' },
    { value: 'l', label: 'Litre (L)' },
    { value: 'ml', label: 'Millilitre (ml)' },
    { value: 'piece', label: 'Pièce' },
    { value: 'portion', label: 'Portion' }
  ];
}
}

export default Stock;